import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    cssClass: null
  },
  setup(__props: any) {



const frontpageUrl = computed<string>(() => store.getters["app/frontpageUrl"]);
const isInEditMode = computed<boolean>(() => store.getters["app/isInEditMode"]);

return { __sfc: true,frontpageUrl, isInEditMode }
}

})